:root {
  --g-top-bar-height: 48px;
  --g-mobile-top: 59px;
  --g-mobile-bottom: 94px;
  --g-mobile-preview-max-height: 512px; }

._verticalGuideContainer_17x7p_7 {
  display: inline-block;
  position: absolute;
  width: 0;
  top: 0; }
  ._verticalGuideContainer_17x7p_7 ._verticalGuideCatcher_17x7p_12 {
    display: inline-block;
    position: absolute;
    left: -5px;
    width: 11px;
    height: 22px; }
    ._verticalGuideContainer_17x7p_7 ._verticalGuideCatcher_17x7p_12:hover {
      cursor: ew-resize; }
    .tools-hidden ._verticalGuideContainer_17x7p_7 ._verticalGuideCatcher_17x7p_12 {
      height: 0; }
      .tools-hidden ._verticalGuideContainer_17x7p_7 ._verticalGuideCatcher_17x7p_12:hover {
        cursor: default; }
    ._verticalGuideContainer_17x7p_7 ._verticalGuideCatcher_17x7p_12 ._verticalGuideHandler_17x7p_24 {
      z-index: 150;
      position: absolute; }
      ._verticalGuideContainer_17x7p_7 ._verticalGuideCatcher_17x7p_12 ._verticalGuideHandler_17x7p_24 .symbol-guidesHandler_regular {
        position: absolute;
        top: 0; }
      ._verticalGuideContainer_17x7p_7 ._verticalGuideCatcher_17x7p_12 ._verticalGuideHandler_17x7p_24 .symbol-guidesHandler_selected {
        position: absolute;
        top: 0;
        left: -2px; }
  ._verticalGuideContainer_17x7p_7 ._verticalGuide_17x7p_7 {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 1px;
    background-color: #91f7fd;
    pointer-events: none; }
    ._verticalGuideContainer_17x7p_7 ._verticalGuide_17x7p_7:hover {
      cursor: default; }
    ._verticalGuideContainer_17x7p_7 ._verticalGuide_17x7p_7._mobileGuide_17x7p_44 {
      z-index: 1; }
  ._verticalGuideContainer_17x7p_7 path {
    fill: #5999ff; }

._horizontalGuideContainer_17x7p_49 {
  position: absolute;
  height: 0;
  width: 0;
  right: 0; }
  ._horizontalGuideContainer_17x7p_49 ._horizontalGuideCatcher_17x7p_54 {
    position: absolute;
    right: 0;
    top: -5px;
    height: 11px;
    width: 22px;
    overflow: hidden; }
    ._horizontalGuideContainer_17x7p_49 ._horizontalGuideCatcher_17x7p_54:hover {
      cursor: ns-resize; }
    .tools-hidden ._horizontalGuideContainer_17x7p_49 ._horizontalGuideCatcher_17x7p_54 {
      width: 0; }
      .tools-hidden ._horizontalGuideContainer_17x7p_49 ._horizontalGuideCatcher_17x7p_54:hover {
        cursor: default; }
    ._horizontalGuideContainer_17x7p_49 ._horizontalGuideCatcher_17x7p_54 ._horizontalGuideHandler_17x7p_67 {
      z-index: 150;
      position: absolute;
      right: -3px;
      top: -4px; }
      ._horizontalGuideContainer_17x7p_49 ._horizontalGuideCatcher_17x7p_54 ._horizontalGuideHandler_17x7p_67 .symbol-guidesHandler_regular,
      ._horizontalGuideContainer_17x7p_49 ._horizontalGuideCatcher_17x7p_54 ._horizontalGuideHandler_17x7p_67 .symbol-guidesHandler_selected {
        transform: rotate(90deg); }
  ._horizontalGuideContainer_17x7p_49 ._horizontalGuide_17x7p_49 {
    position: absolute;
    height: 1px;
    background-color: #91f7fd;
    pointer-events: none; }
    ._horizontalGuideContainer_17x7p_49 ._horizontalGuide_17x7p_49:hover {
      cursor: default; }
  ._horizontalGuideContainer_17x7p_49 path {
    fill: #5999ff; }
